<template>
    <v-container
            id="service-list"
            fluid
            tag="section"
            pt-0
    >
        <v-row>
            <v-col cols="12">
                <v-data-table
                        :headers="headers"
                        :items="serviceList"
                        class="elevation-1"
                        :options.sync="options"
                        :server-items-length="serviceListTotal"
                        @click:row="handleServiceRowClick"
                        :item-class="itemRowBackground"
                        :items-per-page="20"
                        :footer-props="{
                            'items-per-page-options': [20, 50, -1]
                        }"
                >
                    <template v-slot:top>
                        <v-row class="ml-2 mr-2">
                            <v-col cols="6" md="3">
                            <v-text-field
                                    v-model="filter.search"
                                    :label="$vuetify.lang.t('$vuetify.page.Services.search')"
                                    :hide-details="true"
                                    class="mr-3"
                            >
                            </v-text-field>
                            </v-col>
                            <v-col cols="6" md="3">
                            <v-select
                                    dense
                                    outlined
                                    multiple
                                    v-model="filter.status"
                                    :items="serviceStatusList"
                                    item-value="id"
                                    item-text="name"
                                    hide-details="auto"
                                    :clearable="true"
                                    :label="$vuetify.lang.t('$vuetify.page.Services.serviceTypeLabel')"
                                    class="mr-3"
                            ></v-select>
                            </v-col>
                            <v-col cols="6" md="3">
                            <v-select
                                    dense
                                    outlined
                                    multiple
                                    v-model="filter.department"
                                    :items="serviceDepartmentList"
                                    item-value="id"
                                    item-text="name"
                                    hide-details="auto"
                                    :clearable="true"
                                    :label="$vuetify.lang.t('$vuetify.page.Services.serviceDepartment')"
                                    class="mr-3"
                            ></v-select>
                            </v-col>
                            <v-col cols="6" md="3">
                            <rl-datepicker
                                    v-model="filter.datePeriod"
                            ></rl-datepicker>
                            </v-col>
                            <v-spacer></v-spacer>
<!--                            <v-btn-->
<!--                                    color="primary"-->
<!--                                    dark-->
<!--                                    class="mb-2"-->
<!--                                    v-on:click="addService"-->
<!--                            >-->
<!--                                {{$vuetify.lang.t('$vuetify.page.action.btnAdd')}}-->
<!--                            </v-btn>-->
                        </v-row>
                    </template>
                    <template v-slot:item.serviceImportance.name="{ item }">
                        <v-chip
                                :color="serviceImportanceColor(item.serviceImportance.id)"
                                dark
                        >
                            {{item.serviceImportance.name}}
                        </v-chip>
                    </template>
                    <template v-slot:item.serviceDate="{ item }">
                        {{(item.serviceDate ? item.serviceDate : item.history.createdAt) | formatDate}}
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                                v-if="canOpen(item)"
                                small
                                class="mr-2"
                                @click="openService(item.id)"
                        >
                            mdi-card-bulleted-outline
                        </v-icon>
                        <v-icon
                                v-else
                                small
                                class="mr-2"
                                @click="joinService(item.id)"
                        >
                            mdi-clipboard-plus
                        </v-icon>
                    </template>
                    <template v-slot:no-data>
                        Нет данных
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapState} from 'vuex'
    import _ from "lodash";
    import RlDatepicker from "@/view/dashboard/components/rl-datepicker";

    export default {
        name: 'ServiceList',
        components: {RlDatepicker},
        props:{
            assigned: {
                type: String,
                default: null
            },
            search: {
                type: String,
                default: null
            },
            status: {
                type: Array,
                default: null
            },
            department: {
                type: Array,
                default: null
            },
            fromDate: {
                type: String,
                default: null
            },
            toDate: {
                type: String,
                default: null
            },
            page: {
                type: String,
                default: "1"
            },
            itemsPerPage: {
                type: String,
                default: "20"
            }
        },
        created() {
            this.$store.dispatch('checkHub')
            this.$store.dispatch('retrieveServiceStatusDictionaryList')
            this.$store.dispatch('retrieveServiceImportanceDictList')
            this.$store.dispatch('retrieveDepartmentDictionaryList')

            if(this.page){
                this.options.page = this.page * 1
            }
            if (this.itemsPerPage) {
                this.options.itemsPerPage = this.itemsPerPage * 1
            }

            this.getServiceList()

            this.debouncedSearch = _.debounce(this.reloadData, 500)
        },
        computed: {
            ...mapState(['barColor', 'barImage']),
            serviceList() {
                return this.$store.getters.executorServiceList
            },
            serviceListTotal() {
                return this.$store.getters.executorServiceListTotal
            },
            serviceStatusList() {
                return this.$store.getters.serviceStatusDictionaryList.filter(item => item.code !== 'NotProcessed')
            },
            serviceImportanceList() {
                return this.$store.getters.serviceImportanceDictionaryList
            },
            serviceDepartmentList() {
                return this.$store.getters.departmentDictionaryList
            },
            notifications() {
                return this.$store.getters.serviceChangedNotification
            }
        },
        watch: {
            assigned: {
                handler() {
                    this.getServiceList()
                },
                deep: true,
            },
            options: {
                handler() {
                    this.getServiceList()
                },
                deep: true,
            },
            'filter.search': {
                handler()
                {
                    this.debouncedSearch()
                }
            },
            'filter.status': {
                handler()
                {
                    this.reloadData()
                }
            },
            'filter.department': {
                handler() {
                    this.reloadData()
                },
            },
            'filter.datePeriod': {
                handler() {
                    this.reloadData()
                },
                deep: true
            },
            notifications: {
                handler() {
                    this.serviceUp()
                }
            },
            sortBy: {
                type: String,
                default: ""
            },
            sortDesc: {
                type: Boolean
            }
        },
        data() {
            return {
                dialogDelete: false,
                options: {},
                filter: {
                    search: this.search,
                    status: this.status && !Array.isArray(this.status) ? [this.status] : this.status,
                    department: this.department && !Array.isArray(this.department) ? [this.department] : this.department,
                    datePeriod: [
                        this.fromDate,
                        this.toDate
                    ],
                },
                headers: [
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.number'),
                        align: 'start',
                        sortable: true,
                        value: 'number',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.client'),
                        align: 'start',
                        sortable: true,
                        value: 'client.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.serviceType'),
                        align: 'start',
                        sortable: true,
                        value: 'serviceType.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.serviceImportant'),
                        align: 'start',
                        sortable: true,
                        value: 'serviceImportance.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.serviceStatus'),
                        align: 'start',
                        sortable: true,
                        value: 'serviceStatus.name',
                    },
                    {
                        text: this.$vuetify.lang.t('$vuetify.page.Services.serviceDate'),
                        align: 'center',
                        sortable: true,
                        value: 'serviceDate',
                    },
                    {text: this.$vuetify.lang.t('$vuetify.page.action.titleAction'), value: 'actions', sortable: false},
                ],
            }
        },
        methods: {
            generateQuery() {
                let query = {}
                if (this.filter.status) {
                    query.status = this.filter.status
                }
                if (this.filter.department) {
                    query.department = this.filter.department
                }
                if (this.filter.datePeriod[0]) {
                    query.fromDate = this.filter.datePeriod[0]
                }
                if (this.filter.datePeriod[1]) {
                    query.toDate = this.filter.datePeriod[1]
                }
                if (this.filter.search) {
                    query.search = this.filter.search
                }
                if (this.options.page) {
                    query.page = this.options.page + ''
                }
                if (this.options.itemsPerPage) {
                    query.itemsPerPage = this.options.itemsPerPage + ''
                }
                if (this.options.sortBy) {
                    query.sortBy = this.options.sortBy[0]
                }
                if (this.options.sortDesc) {
                    query.sortDesc = this.options.sortDesc[0]
                }

                this.$router.replace({name: "ExecutorServices", query: query}).catch(() => {})
            },
            reloadData(){
                if (this.options.page !== 1) {
                    this.options.page = 1
                } else {
                    this.getServiceList()
                }
            },
            getServiceList() {
                if (this.options.page) {
                    this.generateQuery();
                    let itemPerPage = this.options.itemsPerPage === -1 ? null : this.options.itemsPerPage
                    let offset = itemPerPage ? (this.options.page - 1) * itemPerPage : null
                    let period = this.preparePeriod()
                    this.$store.dispatch('retrieveExecutorServiceList', {
                        offset: offset,
                        limit: itemPerPage,
                        assigned: this.assigned === 'assigned',
                        status: this.filter.status,
                        departmentId: this.filter.department,
                        fromDate: period[0],
                        toDate: period[1],
                        search: this.filter.search,
                        sortBy: this.options.sortBy ? this.options.sortBy[0] : null,
                        sortDesc: this.options.sortDesc ? this.options.sortDesc[0] : null,
                    })
                }
            },
            preparePeriod(){
                if(this.filter.datePeriod[0] === null){
                    return this.filter.datePeriod
                }

                let period = {...this.filter.datePeriod}

                if(!period[1]){
                    period[1] = period[0]
                }

                period[0] += 'T00:00:00'
                period[1] += 'T23:59:59'

                return period
            },
            addService() {
                this._openServiceCard('00000000-0000-0000-0000-000000000000')
            },
            handleServiceRowClick(row){
                this.$store.dispatch('executorOpenService', row.id).then(() => {
                    this._openServiceCard(row.id)
                })
            },
            openService(serviceId) {
                this._openServiceCard(serviceId)
            },
            _openServiceCard(serviceId) {
                this.$router.push({
                    name: 'ExecutorServicesCard',
                    params: {
                        serviceId: serviceId
                    }
                })
            },
            serviceImportanceColor(serviceImportanceId) {
                if(this.serviceImportanceList) {
                    let item = this.serviceImportanceList.find(item => item.id === serviceImportanceId)
                    if(item) {
                        return item.colorHex
                    }

                    return 'transparent'
                }
            },
            canOpen(item){
                return item.executorsCnt > 0
            },
            joinService(serviceId){
                this.$store.dispatch('executorServiceJoin', serviceId).then(() =>
                    this._openServiceCard(serviceId)
                )
            },
            isInFilter(notification){
                let result = true

                if(this.assigned === 'assigned' && notification.executorCnt > 0){
                    result = true
                }

                if (this.filter.status || this.filter.department || this.filter.executor ||
                    this.filter.datePeriod[0] || this.filter.datePeriod[1] || this.filter.search) {
                    result = false
                }

                return result
            },
            serviceUp(){
                this.notifications.slice().reverse().forEach(notification => {
                        this.$store.dispatch('executorServicePushUp', {
                            service: notification,
                            inFilter: this.isInFilter(notification)
                        }).then(() => {
                            // this.$store.dispatch('removeServiceChangedMessage', note.id)
                        })
                })
            },
            itemRowBackground(item){
                if(item.isExpired){
                    return 'red lighten-4'
                }
                if(item.isUnread){
                    return 'amber lighten-4'
                }

                return ''
            }
        },
    }
</script>
